import script from "./cardapio-armazem.vue?vue&type=script&setup=true&lang=js"
export * from "./cardapio-armazem.vue?vue&type=script&setup=true&lang=js"

import "./cardapio-armazem.vue?vue&type=style&index=0&id=a295f882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a295f882"]])

export default __exports__